import React from 'react';
import { Input, Button, Select, PaperClip } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { UserService } from 'services';
import { WhiteImage } from 'assets/img';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalPassword extends React.Component<Props> {

	state = {
		form: {
			password: '',
			password_confirmation: ''
		}
	}

	submit = async (e: any) => {
		e.preventDefault();
		await UserService.admin.updatePassword({
			user_id: this.props.item?.id,
			...this.state.form
		});
		Globals.showSuccess("Se ha actualizado el usuario correctamente");
		this.props.onClose();
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-create-user">
				<form onSubmit={ this.submit }>
					<div className="row">
						<div className="col-md-6">
							<Input
								type="number"
								color="white"
								value={ this.state.form.password }
								name="password" 
								label="Nueva contraseña"
								placeholder="Contraseña"
								maxLength="6"
								onChange={ this.change } />
						</div>
						<div className="col-md-6">
							<Input
								type="number"
								color="white"
								value={ this.state.form.password_confirmation }
								name="password_confirmation" 
								label="Repetir contraseña"
								placeholder="Contraseña"
								maxLength="6"
								onChange={ this.change } />
						</div>
					</div>
					<p className="note">La contraseña debe ser un número de 6 dígitos</p>
					<div className="text-center">
						<Button type="submit" className="btn-save">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default ModalPassword;